<template>
    <a :href="getModuleUrl($route.params.companyId, item)" style="cursor: pointer;" class="w-100 h-100 d-inline-block text-dark">
        <!-- <div class="card-body"> -->
            <div class="avatar mb-1">
                <div class="avatar-content">
                    <img :src="item.icon" alt="" width="50">
                </div>
            </div>
            <!-- <h2 class="fw-bolder">{{ page.status }}</h2> -->
            <p style="height: 25px;" class="card-text">{{ item.name }}</p>
        <!-- </div> -->
    </a>
</template>

<script>
import handleSidebar from "@/services/modules/sidebar";
export default {
    name: 'ModuleCard',
    props: ['item'],
    setup() {
      const {
        getModuleUrl
      } = handleSidebar()

      return {
        getModuleUrl,
      }
    }
}
</script>

<style scoped>
    .pageCard:hover{
        padding: 10px;
        margin: 10px !important;
        box-sizing: border-box !important;
        cursor: pointer;

    }
    hr{
        margin: 0;
    }
     .avatar{
        width: 80px;
        height: 80px;
        border-radius: 10%;
        background-color: #FFFFFF;
    }
     .avatar img{
       border-radius: 0% !important;
     }

    .avatar-content{
        margin: auto !important;
        width: 70px;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #ddd;
        border-radius: 15px;
        background-color: #f8f9fa;
        transition: transform 0.3s ease, background-color 0.3s ease;
    }
    .avatar-content:hover{
      width: 80px;
      height: 80px;
      background-color: #e7f3ff;
      transform: scale(1.15);
    }
    @media screen and (max-width: 400px){
        .pageCard{
            width: 50%;
        }
         .pageCard{
        padding: 0px;
        margin: 0px !important;
        /* background-color: #DBE7F2; */
        box-sizing: border-box !important;

    }
    .pageCard:hover{
        padding: 0px;
        margin: 0px !important;
        background-color: #DBE7F2;
        border-radius: 10px;
        box-sizing: border-box !important; 
    }
    /* .pageCard:hover>.avatar {
        border: 100px solid red;
    } */
    }
</style>